import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function TGrupoCli() {
    const [grupos, setGrupos] = useState([]);
    const [gruposFiltrados, setGruposFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [formulario, setFormulario] = useState({
        idGrupocli: '',
        nomGrupocli: ''
    });

    const API_URL = '/api/gruposcli';

    useEffect(() => {
        cargarGrupos();
    }, []);

    useEffect(() => {
        filtrarGrupos();
    }, [busqueda, grupos]);

    const cargarGrupos = async () => {
        try {
            const response = await axios.get(API_URL);
            setGrupos(response.data);
            setGruposFiltrados(response.data);
        } catch (error) {
            console.error('Error al cargar grupos de clientes:', error);
            alert('Error al cargar los grupos de clientes');
        }
    };

    const filtrarGrupos = () => {
        if (!busqueda) {
            setGruposFiltrados(grupos);
            return;
        }

        const filtrados = grupos.filter(grupo =>
            grupo.idGrupocli?.toString().includes(busqueda) ||
            grupo.nomGrupocli?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setGruposFiltrados(filtrados);
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idGrupocli: '',
            nomGrupocli: ''
        });
        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (grupo) => {
        setFormulario({
            idGrupocli: grupo.idGrupocli,
            nomGrupocli: grupo.nomGrupocli
        });
        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setFormulario({
            idGrupocli: '',
            nomGrupocli: ''
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formulario.nomGrupocli.trim()) {
            alert('El nombre del grupo es requerido');
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.idGrupocli}`, formulario);
                alert('Grupo de cliente actualizado exitosamente');
            } else {
                await axios.post(API_URL, formulario);
                alert('Grupo de cliente creado exitosamente');
            }
            cargarGrupos();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar el grupo de cliente');
        }
    };

    const eliminar = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este grupo de cliente?')) {
            try {
                await axios.delete(`${API_URL}/${id}`);
                alert('Grupo de cliente eliminado exitosamente');
                cargarGrupos();
            } catch (error) {
                console.error('Error al eliminar:', error);
                alert('Error al eliminar el grupo de cliente');
            }
        }
    };

    const exportarExcel = () => {
        const datosExportar = gruposFiltrados.map(grupo => ({
            'ID': grupo.idGrupocli,
            'Nombre': grupo.nomGrupocli
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Grupos de Clientes');
        XLSX.writeFile(workbook, 'grupos_clientes.xlsx');
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Grupos de Clientes</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo Grupo
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre del Grupo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {gruposFiltrados.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="sin-datos">No hay grupos de clientes para mostrar</td>
                            </tr>
                        ) : (
                            gruposFiltrados.map(grupo => (
                                <tr key={grupo.idGrupocli}>
                                    <td>{grupo.idGrupocli}</td>
                                    <td>{grupo.nomGrupocli}</td>
                                    <td>
                                        <button
                                            onClick={() => abrirModalEditar(grupo)}
                                            className="btn-accion"
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            onClick={() => eliminar(grupo.idGrupocli)}
                                            className="btn-accion"
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="footer-tabla">
                Total de grupos: {gruposFiltrados.length}
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido">
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Grupo de Cliente' : 'Nuevo Grupo de Cliente'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Nombre del Grupo *</label>
                                <input
                                    type="text"
                                    value={formulario.nomGrupocli}
                                    onChange={(e) => setFormulario({ ...formulario, nomGrupocli: e.target.value })}
                                    required
                                    maxLength={50}
                                    placeholder="Ingrese el nombre del grupo"
                                />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TGrupoCli;
